import { always, cond, either, startsWith, T } from "ramda"
import { isVMHostOrGuest } from "./devices"

export const isWindowsPolicy = nodeRole => nodeRole.startsWith("WINDOWS_")

export const isMacPolicy = nodeRole => nodeRole.startsWith("MAC")

export const isLinuxPolicy = nodeRole => nodeRole.startsWith("LINUX")

export const isWindowsOrMacPolicy = nodeRole => isWindowsPolicy(nodeRole) || isMacPolicy(nodeRole)

export const isMDMPolicy = either(startsWith("ANDROID"), startsWith("APPLE_IOS"))

export const getEditorType = cond([
  [isVMHostOrGuest, always("vmpolicy")],
  [isMDMPolicy, always("mdmpolicy")],
  [T, always("policy")],
])

export const getPolicyRoute = ({ nodeRole, nodeClass, id }) => {
  const editorType = getEditorType(nodeRole ?? nodeClass)

  return `#/editor/${editorType}/${id}`
}

export const getParentPolicyInfo = policy => {
  const { parentPolicyId, parentPolicyName } = policy || {}
  return parentPolicyId
    ? {
        name: parentPolicyName,
        link: getPolicyRoute({ ...policy, id: parentPolicyId }),
      }
    : null
}

export const getDefaultSchedule = isScan => {
  return {
    scheduleType: "DAILY",
    weekDays: [isScan ? "FRI" : "SUN"],
    scheduleHour: 17,
    scheduleMinute: 0,
    scheduleDuration: 0,
    scheduleDurationHours: 0,
    scheduleDurationMinutes: 0,
    timeZone: "_Local",
  }
}
